async function callEmail(payload) {
  try {
    const res = await fetch('/.netlify/functions/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      console.warn('[AVÉLIS email] echec', payload.type, res.status, txt);
    }
    return res.ok;
  } catch(e) {
    console.warn('[AVÉLIS email] echec', payload.type, 'reseau', e);
    return false;
  }
}

export async function envoyerEmailBienvenue(emailPro, prenom, activite, lien) {
  await callEmail({ type: 'bienvenue', to: emailPro, prenom, activite, lien });
}

// avec (facultatif) : la personne de l'équipe qui fait le RDV (salon en équipe).
export async function envoyerEmailRDV(emailPro, nomPro, nomClient, tel, date, heure, prestations, total, nomSalon, proId, adresseClient, commentaire, avec) {
  await callEmail({ type: 'rdv', to: emailPro || '', nomPro, nomClient, tel, date, heure, prestations, total, nomSalon, proId, adresseClient, commentaire, avec: avec || undefined });
}

export async function envoyerEmailConfirmationClient(emailClient, nomClient, date, heure, prestations, total, nomSalon, adressePro, telPro, duree, regleEmpreinte, regleTitre, avec) {
  // regleEmpreinte (facultatif) : la phrase de la garantie (empreinte OU acompte),
  // répétée dans l'email — c'est la preuve écrite de la règle acceptée en cas de
  // contestation. regleTitre (facultatif) : le titre du bloc — sans lui, le titre
  // historique « empreinte bancaire » s'affiche.
  await callEmail({ type: 'confirmation_client', to: emailClient, nomClient, date, heure, prestations, total, nomSalon, adressePro, tel: telPro, duree, regleEmpreinte: regleEmpreinte || undefined, regleTitre: regleTitre || undefined, avec: avec || undefined });
}

// ancienneHeure, adresseSalon (facultatifs) : l'heure d'origine, barrée avec l'ancienne
// date, et l'adresse du salon du jour pour un pro multi-salons.
export async function envoyerEmailRepositionnement(emailClient, nomClient, ancienneDate, nouvelleDate, nouvelleHeure, prestations, nomSalon, ancienneHeure, adresseSalon) {
  await callEmail({ type: 'repositionnement', to: emailClient, nomClient, date: nouvelleDate, heure: nouvelleHeure, prestations, nomSalon, ancienneDate, ancienneHeure: ancienneHeure || undefined, adressePro: adresseSalon || undefined });
}
